export const genMessage = (data: any) => ({
	type: data.type,
	receivers: data.receivers,
	msg: {
		notification: {
			title: data.title,
			body: data.body,
		},
		data: JSON.stringify(data.data),
		android: {
			notification: {
				channelId: 'dispatcher_background_channel_id',
			},
			priority: data.prioity,
		},
	}
});
